// Required Libraries
import React, { Component } from 'react';
import Modal from 'react-bootstrap/Modal';
import styled from '@emotion/styled';
import ValidForm from './ValidForm';

const BootstrapModal = styled(Modal)`
	.form-contain {
		margin-bottom: 0px;
	}

	.modal-content {
		text-align: left;
		.modal-header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			font-weight: bold;
			h4 {
				font-size: 20px;
			}
			.close {
				font-size: 34px;
				font-weight: bold;
				background-color: transparent;
				border: none;
				&:focus {
					outline: none;
				}
			}
		}
	}

	.modal-dialog {
		transform: translate(0, 0) !important;
	}
	@media only screen and (max-width: 768px) {
		.modal-footer {
			.button-wrap {
				flex-direction: column-reverse;
				.btn {
					min-height: 44px;
					font-size: 18px !important;
					margin-left: 0px !important;
				}
				.guest {
					margin-top: 10px;
					margin-right: 0px !important;
				}
			}
		}
	}
`;

const ModalContain = styled.div`
	.modal-backdrop {
		opacity: 0.5;
	}
`;

class LoginModal extends Component {
	constructor(props) {
		super(props);

		this.state = {
			show: false
		};

		/*
			This will show and hide the modal when clicked
		*/
		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
	}

	handleClose() {
		this.setState({ show: false });
	}

	handleShow() {
		this.setState({ show: true });
	}

	inputEmailAddress(evt) {
		let emailAddress = evt.target.value;
		this.setState({
			emailAddress
		});
	}

	inputPassword(evt) {
		let password = evt.target.value;
		this.setState({
			password
		});
	}

	render() {
		return (
			<div>
				<a className='hide js-react-login-modal' onClick={this.handleShow}>
					Log in now
				</a>

				<ModalContain>
					<BootstrapModal
						className='login-modal in'
						show={this.state.show}
						onHide={this.handleClose}
					>
						<div className='form-contain'>
							<ValidForm handleClose={this.handleClose} />
						</div>
					</BootstrapModal>
				</ModalContain>
			</div>
		);
	}
}

export default LoginModal;

// pageLayer - use to autofill email address
